import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Input, Select, Tag, DatePicker } from "antd";
import Menubar from "../../../components/WhrManager/App";
import { SearchOutlined } from "@ant-design/icons";
import debounce from "lodash.debounce";
import Highlighter from "react-highlight-words";
import moment from "moment";
import HeaderWithInfinityScroll from "../../../components/HeaderWithInfinityScroll";
import DirectModal from "./Modal/directModal";
import TransportModal from "./Modal/transportModal";
import axios from "axios";
import { session } from "../../../services/session";
import { config } from "../../../config";

const get = async (url) => {
  const token = session.get();
  const headers = {};

  if (token) {
    headers[config.backendTokenKEY] = `Bearer ${token}`;
  }

  return await axios.get(url, { headers });
};

const PurchaseLoadedGoods = () => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [typeOfTransport, setTypeOfTransport] = useState("");
  const [numberOfTransport, setNumberOfTransport] = useState("");
  const [partyNumber, setPartyNumber] = useState("");
  const [directionType, setDirectionType] = useState("");
  const [total, setTotal] = useState("");
  const [isDirectModalVisible, setIsDirectModalVisible] = useState(false);
  const [isTransportModalVisible, setIsTransportModalVisible] = useState(false);

  const orderStatus = [
    { label: "Barchasi", value: "" },
    { label: "So'rov yuborilsin", value: "SurovYuborilsin" },
    { label: "So'rov yuborildi", value: "SurovYuborildi" },
    { label: "Yuk ko'chirildi", value: "YukKochirildi" },
  ];

  const [selectedCardName, setSelectedCardName] = useState("");
  const [selectedDocNum, setSelectedDocNum] = useState("");
  const [filterCardName, setFilterCardName] = useState("");
  const [filterRegDate, setFilterRegDate] = useState("");
  const [filterCompDate, setFilterCompDate] = useState("");
  const [filterPartyNumber, setFilterPartyNumber] = useState("");
  const [filterDirectionType, setFilterDirectionType] = useState("");
  const [filterTransportType, setFilterTransportType] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterDocNum, setFilterDocNum] = useState("");
  const [allData, setAllData] = useState([]);

  const applyFilters = useCallback(
    (data = allData) => {
      let filtered = [...data];

      // Yetkazib beruvchi filter
      if (filterCardName) {
        filtered = filtered.filter((item) =>
          item.cardName?.toLowerCase().includes(filterCardName.toLowerCase()),
        );
      }

      // Registratsiya sanasi filter
      if (filterRegDate) {
        filtered = filtered.filter((item) => {
          const itemDate = moment(item.docDate).format("YYYY-MM-DD");
          return itemDate === filterRegDate;
        });
      }

      // Bajarilgan sanasi filter
      if (filterCompDate) {
        filtered = filtered.filter((item) => {
          const itemDate = moment(item.docDueDate).format("YYYY-MM-DD");
          return itemDate === filterCompDate;
        });
      }

      // Partiya raqami filter
      if (filterPartyNumber) {
        filtered = filtered.filter((item) =>
          item.U_PartyNumber?.toLowerCase().includes(
            filterPartyNumber.toLowerCase(),
          ),
        );
      }

      // Yo'nalish turi filter
      if (filterDirectionType) {
        filtered = filtered.filter(
          (item) => item.U_DirectionType === filterDirectionType,
        );
      }

      // Transport turi filter
      if (filterTransportType) {
        filtered = filtered.filter(
          (item) => item.U_typeOfTransport === filterTransportType,
        );
      }

      // Status filter
      if (filterStatus) {
        filtered = filtered.filter((item) => item.U_Status === filterStatus);
      }

      // Harid hujjati filter
      if (filterDocNum) {
        filtered = filtered.filter((item) =>
          item.docNum?.toString().includes(filterDocNum),
        );
      }

      setDataSource(filtered);
    },
    [
      filterCardName,
      filterRegDate,
      filterCompDate,
      filterPartyNumber,
      filterDirectionType,
      filterTransportType,
      filterStatus,
      filterDocNum,
      allData,
    ],
  );

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const baseUrl = `https://api.new.krupasnab.uz/api/Purchase/purchase-invoices-supplier`;
      const queryParams = new URLSearchParams();
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);
      const url = queryParams.toString()
        ? `${baseUrl}?${queryParams.toString()}`
        : baseUrl;

      const { data } = await get(url);
      // u_IsTransferMade = "Yes" bo'lgan ma'lumotlarni filter qilish
      const filteredData = data.filter(
        (item) => item.u_IsTransferMade === "Yes",
      );
      // Sana (docDate) bo'yicha teskari tartibda sort qilish — hozirgi vaqtdan orqaga
      const sortedData = filteredData.sort((a, b) => {
        const dateA = a.docDate ? new Date(a.docDate).getTime() : 0;
        const dateB = b.docDate ? new Date(b.docDate).getTime() : 0;
        return dateB - dateA; // Yangi sanalar birinchi (kamayish tartibi)
      });
      setAllData(sortedData);
      setHasMoreData(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (allData.length > 0) {
      applyFilters();
    }
  }, [applyFilters, allData]);

  const handleNextPage = () => {
    if (hasMoreData) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleRowClick = (record) => {
    setSelectedRowData(record);
    if (record.U_DirectionType === "transit") {
      setIsTransportModalVisible(true);
    } else if (record.U_DirectionType === "direct") {
      setIsDirectModalVisible(true);
    }
  };

  const handleStartDate = (e) => {
    setCurrentPage(0);
    setStartDate(e.target.value);
  };

  const handleEndDate = (e) => {
    setCurrentPage(0);

    setEndDate(e.target.value);
  };

  let searchInput = null;

  const debouncedSearch = useMemo(
    () =>
      debounce((value, dataIndex, confirm) => {
        if (dataIndex === "docNum") {
          if (value) {
            // setCurrentPage(0);

            setSelectedDocNum(value);
          } else {
            // setCurrentPage(0);

            setSelectedDocNum("");
          }
        }
        if (dataIndex === "cardName") {
          if (value) {
            // setCurrentPage(0);

            setSelectedCardName(value);
          } else {
            // setCurrentPage(0);

            setSelectedCardName("");
          }
        }
        if (dataIndex === "U_typeOfTransport") {
          if (value) {
            setTypeOfTransport(value);
          } else {
            setTypeOfTransport("");
          }
        }
        if (dataIndex === "U_NumberOfTransport") {
          if (value) {
            setNumberOfTransport(value);
          } else {
            setNumberOfTransport("");
          }
        }
        if (dataIndex === "U_PartyNumber") {
          if (value) {
            setPartyNumber(value);
          } else {
            setPartyNumber("");
          }
        }
        if (dataIndex === "U_DirectionType") {
          if (value) {
            setDirectionType(value);
          } else {
            setDirectionType("");
          }
        }
        setCurrentPage(0);
        confirm();
      }, 1000),
    [],
  );

  const handleSearch = (e, confirm, dataIndex) => {
    const value = e.target.value;

    debouncedSearch(value, dataIndex, confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
            handleSearch(e, confirm, dataIndex);
          }}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Yetkazib beruvchi",
      dataIndex: "cardName",
      key: "cardName",
      width: 150,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ padding: 8 }}>
            <Select
              showSearch
              placeholder="Yetkazib beruvchi tanlang"
              value={filterCardName || undefined}
              onChange={(value) => {
                setFilterCardName(value || "");
              }}
              allowClear
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={uniqueCardNames.map((name) => ({
                label: name,
                value: name,
              }))}
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
          </div>
        );
      },
      ...getColumnSearchProps("cardName"),
    },
    {
      title: "Registratsiya sanasi",
      dataIndex: "docDate",
      key: "docDate",
      width: 120,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ padding: 8 }}>
            <DatePicker
              placeholder="Registratsiya sanasi"
              value={filterRegDate ? moment(filterRegDate) : null}
              onChange={(date) => {
                setFilterRegDate(date ? date.format("YYYY-MM-DD") : "");
              }}
              format="DD-MM-YYYY"
              style={{ width: 188, marginBottom: 8, display: "block" }}
              allowClear
            />
          </div>
        );
      },
      render: (text, record) => {
        return text ? moment(text).format("DD-MM-YYYY") : "-";
      },
    },
    {
      title: "Bajarilish sanasi",
      dataIndex: "docDueDate",
      key: "docDueDate",
      width: 120,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ padding: 8 }}>
            <DatePicker
              placeholder="Bajarilish sanasi"
              value={filterCompDate ? moment(filterCompDate) : null}
              onChange={(date) => {
                setFilterCompDate(date ? date.format("YYYY-MM-DD") : "");
              }}
              format="DD-MM-YYYY"
              style={{ width: 188, marginBottom: 8, display: "block" }}
              allowClear
            />
          </div>
        );
      },
      render: (text, record) => {
        return text ? moment(text).format("DD-MM-YYYY") : "-";
      },
    },
    {
      title: "Partiya raqami",
      dataIndex: "U_PartyNumber",
      key: "U_PartyNumber",
      width: 120,
      render: (text, record) => {
        return text || "-";
      },
      ...getColumnSearchProps("U_PartyNumber"),
    },
    {
      title: "Transport raqami",
      dataIndex: "U_NumberOfTransport",
      key: "U_NumberOfTransport",
      width: 150,
      render: (text, record) => {
        return text || "-";
      },
      ...getColumnSearchProps("U_NumberOfTransport"),
    },
    {
      title: "Yo'nalish turi",
      dataIndex: "U_DirectionType",
      key: "U_DirectionType",
      width: 150,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ padding: 8 }}>
            <Select
              placeholder="Yo'nalish turi tanlang"
              value={filterDirectionType || undefined}
              onChange={(value) => {
                setFilterDirectionType(value || "");
              }}
              allowClear
              style={{ width: 188, marginBottom: 8, display: "block" }}
            >
              <Select.Option value="">Barchasi</Select.Option>
              <Select.Option value="transit">Tranzit</Select.Option>
              <Select.Option value="direct">To'g'ridan to'g'ri</Select.Option>
            </Select>
          </div>
        );
      },
      render: (text, record) => {
        return (
          (text && text === "transit" ? (
            <Tag color="blue">Tranzit</Tag>
          ) : text === "direct" ? (
            <Tag color="green">To'g'ridan to'g'ri</Tag>
          ) : (
            text
          )) || "-"
        );
      },
    },
    {
      title: "Transport turi",
      dataIndex: "U_typeOfTransport",
      key: "U_typeOfTransport",
      width: 150,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ padding: 8 }}>
            <Select
              showSearch
              placeholder="Transport turi tanlang"
              value={filterTransportType || undefined}
              onChange={(value) => {
                setFilterTransportType(value || "");
              }}
              allowClear
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={uniqueTransportTypes.map((type) => ({
                label: type,
                value: type,
              }))}
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
          </div>
        );
      },
      render: (text, record) => {
        return text || "-";
      },
      ...getColumnSearchProps("U_typeOfTransport"),
    },
    {
      title: "Miqdori",
      dataIndex: "totalQty",
      key: "totalQty",
      width: 120,
      render: (text, record) => {
        return text
          ? new Intl.NumberFormat("fr-FR").format(text) +
              (record.buyUnitMsr ? ` ${record.buyUnitMsr}` : "")
          : "-";
      },
    },
    {
      title: "Status",
      dataIndex: "U_Status",
      key: "U_Status",
      width: 100,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ padding: 8 }}>
            <Select
              placeholder="Status tanlang"
              value={filterStatus || undefined}
              onChange={(value) => {
                setFilterStatus(value || "");
              }}
              allowClear
              style={{ width: 188, marginBottom: 8, display: "block" }}
            >
              <Select.Option value="">Barchasi</Select.Option>
              <Select.Option value="1">Поступления булган</Select.Option>
              <Select.Option value="2">Поступления булмаган</Select.Option>
            </Select>
          </div>
        );
      },
      render: (text, record) => {
        if (text === "1") {
          return "Поступления булган";
        } else if (text === "2") {
          return "Поступления булмаган";
        }
        return text || "-";
      },
    },
    {
      title: "№ Harid hujjati",
      dataIndex: "docNum",
      key: "docNum",
      width: 120,
      render: (text, record) => {
        return text || "-";
      },
      ...getColumnSearchProps("docNum"),
    },
  ];

  const refetchTable = () => {
    setCurrentPage(0);
    fetchData();
  };

  // Unique qiymatlarni olish
  const uniqueCardNames = useMemo(() => {
    const names = allData.map((item) => item.cardName).filter(Boolean);
    return [...new Set(names)].sort();
  }, [allData]);

  const uniqueDirectionTypes = useMemo(() => {
    const types = allData.map((item) => item.U_DirectionType).filter(Boolean);
    return [...new Set(types)];
  }, [allData]);

  const uniqueTransportTypes = useMemo(() => {
    const types = allData.map((item) => item.U_typeOfTransport).filter(Boolean);
    return [...new Set(types)].sort();
  }, [allData]);

  return (
    <div className="flex h-full w-full overflow-y-auto">
      <Menubar />
      <HeaderWithInfinityScroll
        title="Skladga tushirilgan yuklar"
        currentPage={currentPage + 1}
        handlePreviousPage={handlePreviousPage}
        handleNextPage={handleNextPage}
        hasMoreData={hasMoreData}
        columns={columns}
        fdata={dataSource}
        loading={loading}
        onStartDateChange={handleStartDate}
        onEndDateChange={handleEndDate}
        startDate={startDate}
        endDate={endDate}
        formattedDate={moment().format("YYYY-MM-DD")}
        handleRowClick={handleRowClick}
        total={total}
      />
      <DirectModal
        visible={isDirectModalVisible}
        data={selectedRowData}
        onClose={() => setIsDirectModalVisible(false)}
        refetch={refetchTable}
      />
      <TransportModal
        visible={isTransportModalVisible}
        data={selectedRowData}
        onClose={() => setIsTransportModalVisible(false)}
        refetch={refetchTable}
      />
    </div>
  );
};

export default PurchaseLoadedGoods;
